import { getApartmentEntryPosition } from "./index156.js";
import { getCoreEntryPosition } from "./index157.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { Vector3toV3, getPivot } from "@project-rouge/rg-three";
function getEntranceDistance(unit) {
	let entryPos = [
		0,
		0,
		0
	];
	if (unit.type === RG_TYPE.Apartment) entryPos = getApartmentEntryPosition(unit);
	else if (unit.type === RG_TYPE.Core) entryPos = getCoreEntryPosition(unit);
	else Vector3toV3(getPivot([
		.5,
		0,
		0
	], unit));
	return (1 - unit.anchor[0]) * unit.size[0] - entryPos[0];
}
export { getEntranceDistance };

//# sourceMappingURL=index158.js.map